export default "__VITE_ASSET__DMBlJ_Jx__"